import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import config from '../../config';
import { ReducePotList } from './ReducePotList';
import HashcodeUtils from '../../utils/HashcodeUtils';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import NumberUtils from '../../utils/NumberUtils';
import AccountsStore from '../../stores/AccountsStore';
import { BasicModal } from '../common/modals/BasicModal';
import BrowserUtils from '../../utils/BrowserUtils';
import AnyQuestions from '../help/AnyQuestions';
import AccountsActionCreator from '../../actions/AccountsActionCreator';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';

let initialUnallocatedAmount;
const interPotData = {
  source_id: '',
  transactions: [],
};

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work should be done to increase the overall health of the
 * codebase.
 */
class ReducePot extends Component {
  constructor(props) {
    super(props);

    this.getHeaderClass = this.getHeaderClass.bind(this);
    this._alertEditErrorModal = this._alertEditErrorModal.bind(this);
    this._closeAlertModal = this._closeAlertModal.bind(this);
    this._getAccountNumber = this._getAccountNumber.bind(this);
    this._getCurrentBalance = this._getCurrentBalance.bind(this);
    this._getLeftProgress = this._getLeftProgress.bind(this);
    this._handleInterPot = this._handleInterPot.bind(this);
    this._onChildToggle = this._onChildToggle.bind(this);
    this.closeFaq = this.closeFaq.bind(this);
    this.openFaq = this.openFaq.bind(this);

    this.state = {
      totalAllocatedValue: null,
      currentBalanceValue: this._getCurrentBalance(),
      balance: null,
      progressColor: 'red',
      selections: [],
      isValid: 'hide',
      accountNumber: this._getAccountNumber(),
      errorModal: false,
    };
  }

  componentWillMount() {
    BrowserUtils.isMobileView() && SiteHeaderActionCreator.hideHeaderFlag(true);
    if (!_.isEmpty(this.props.interPotError)) {
      this.setState({ errorModal: true });
    }
  }

  componentDidMount() {
    const selections = this.state.selections;
    initialUnallocatedAmount =
      this.state.currentBalanceValue - selections.reduce((a, b) => a + b, 0);
    this.setState({
      totalAllocatedValue: selections.reduce((a, b) => a + b, 0),
      balance:
        this.state.currentBalanceValue - selections.reduce((a, b) => a + b, 0),
    });
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.hideHeaderFlag(false);
  }

  getHeaderClass(e) {
    this.setState({ headerClass: e });
  }

  _alertEditErrorModal() {
    if (this.state.errorModal) {
      return (
        <BasicModal>
          <div className="modal_content">
            <h3>{this.props.interPotError.error.message}</h3>
            <p>
              {this.props.content.potSupportMessage1}
              <br />
              {this.props.content.potSupportMessage2}
              <br />
              {this.props.interPotError.error.quoteId}
            </p>
          </div>
          <div className="modal_footer">
            <button onClick={this._closeAlertModal}>
              {this.props.content.ok}
            </button>
          </div>
        </BasicModal>
      );
    } else {
      return false;
    }
  }

  _closeAlertModal() {
    SavingPotsActionCreator.closetErrorModal();
    this.setState({ errorModal: false });
  }

  _getAccountNumber() {
    const seletedAccountData = AccountsStore.getAccountDetail(
      this.props.getSelectedAccountID
    );
    const accountNumber = _.last(_.split(seletedAccountData.number, '-'));
    return accountNumber;
  }

  _getCurrentBalance() {
    let currentBalance;
    const accDetails = this.props.accDetails;
    if (accDetails && accDetails.balances) {
      _.map(accDetails.balances, (balance) => {
        switch (balance.type) {
          case 'current':
            currentBalance = balance.amount;
            break;
        }
        return false;
      });
    }
    return currentBalance;
  }

  _getLeftProgress() {
    let leftProgressbar;
    if (this.state.balance || this.state.balance === 0) {
      if (this.state.balance >= 0) {
        leftProgressbar = (
          <div className="vertical-progress">
            <span className="percentage green" style={{ height: '25%' }} />
            <div className="rejigMessage">
              <div>
                {this.props.content.savingpotreducemessage2}{' '}
                <strong>
                  {NumberUtils.appendCurrency(
                    '{}',
                    Math.abs(this.state.balance)
                  )}
                </strong>
              </div>
            </div>
          </div>
        );
      } else {
        let percentage = Math.round(
          (Math.abs(this.state.balance) / Math.abs(initialUnallocatedAmount)) *
            100
        );
        if (percentage > 100) {
          percentage = 100;
        }
        if (
          Math.abs(initialUnallocatedAmount) === Math.abs(this.state.balance)
        ) {
          leftProgressbar = (
            <div className="vertical-progress">
              <span className="percentage red" style={{ height: '100%' }} />
              <div className="rejigMessage">
                <div>
                  {this.props.content.savingpotreducemessage1}{' '}
                  <strong>
                    {NumberUtils.appendCurrency(
                      '{}',
                      Math.abs(this.state.balance)
                    )}
                  </strong>
                </div>
              </div>
            </div>
          );
        } else {
          leftProgressbar = (
            <div className="vertical-progress">
              <span
                className="percentage red"
                style={{ height: `${percentage}%` }}
              />
              <div className="rejigMessage">
                <div>
                  {this.props.content.savingpotreducemessage1}{' '}
                  <strong>
                    {NumberUtils.appendCurrency(
                      '{}',
                      Math.abs(this.state.balance)
                    )}
                  </strong>
                </div>
              </div>
            </div>
          );
        }
      }
      return leftProgressbar;
    }
  }

  _handleInterPot() {
    const accDetails = this.props.accDetails;
    const obj = {
      source_id: interPotData.source_id,
      transactions: [],
    };
    interPotData.transactions.forEach((item) => {
      if (item) {
        obj.transactions.push(item);
      }
    });
    SavingPotsActionCreator.getInterPotData(obj);
    AccountsActionCreator.getAccountDetails(accDetails.id);
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_saving_goal_list,
        event: 'click',
      }
    );
  }

  _onChildToggle(id, selected, obj) {
    const selections = this.state.selections;
    selections[id] = selected;
    if (_.isEmpty(obj)) {
      delete interPotData.transactions[id];
    } else {
      interPotData.transactions[id] = obj;
    }
    this.setState({ selections });
    this.setState({
      totalAllocatedValue: selections.reduce((a, b) => a + b, 0),
      balance:
        this.state.currentBalanceValue - selections.reduce((a, b) => a + b, 0),
    });
    const source_id = HashcodeUtils.getSourceId(interPotData);
    interPotData.source_id = source_id;
  }

  closeFaq() {
    this.setState({ faqFlag: false });
  }

  openFaq() {
    this.setState({ faqFlag: true });
  }

  render() {
    let headerContent;
    let balanceHeaderContent;
    const { content, pots } = this.props;

    const totalAllocatedValue = NumberUtils.appendCurrency(
      '{}',
      Number(this.state.totalAllocatedValue)
    );
    const currentBalanceValue = NumberUtils.appendCurrency(
      '{}',
      Number(this.state.currentBalanceValue)
    );

    const innerHeaderContent = (
      <div className="row no-gutters" style={{ overflow: 'hidden' }}>
        <div className="col-xs-3 text-left">
          <button
            className="page-back"
            onClick={this.props.getPotPageHandleClick}
          >
            <span className="icon icon-page-back" />
            {content.back}
          </button>
        </div>
        <div className="col-xs-6 text-center">
          <div className="savingpot_component__header--title">
            {content.savingPotReduce}
          </div>
        </div>
        <div className="col-xs-3 text-right">
          {this.state.balance >= 0 ? (
            <button
              className="page-options-back"
              onClick={this._handleInterPot}
            >
              {this.props.content.savingDone}
            </button>
          ) : null}
        </div>
      </div>
    );

    if (BrowserUtils.isMobileView()) {
      headerContent = (
        <div
          className={`savingpot_component__header ${
            this.state.balance >= 0 ? 'green' : 'red'
          }`}
        >
          {innerHeaderContent}
        </div>
      );
      balanceHeaderContent = (
        <div className="balances">
          <div className="balances-item">
            <p>{content.savingpotcurrentbankmobile}</p>
            <div className="balance">{currentBalanceValue}</div>
          </div>
          <div className="balances-item">
            <p>{content.savingpottotalallocated}</p>
            <div className="balance">{totalAllocatedValue}</div>
          </div>
        </div>
      );
    } else {
      headerContent = (
        <div className="savingpot_component__header">{innerHeaderContent}</div>
      );
      balanceHeaderContent = (
        <div className="balances">
          <div className="balances-item">
            <p>
              {content.savingpotcurrentbank} {this.state.accountNumber}
            </p>
            <div className="balance">{currentBalanceValue}</div>
          </div>
          <div className="balances-item">
            <p>{content.savingpottotalallocated}</p>
            <div className="balance">{totalAllocatedValue}</div>
          </div>
        </div>
      );
    }

    return this.state.faqFlag ? (
      <div>
        <AnyQuestions {...this.props} closed={this.closeFaq} />
      </div>
    ) : (
      <div
        className={`main-container${
          BrowserUtils.isMobileView() ? ' from-top' : ''
        }`}
      >
        {this._alertEditErrorModal()}
        <div className={`reducePot full-height sp ${this.props.accountClass}`}>
          {headerContent}
          <div className="scroll-wrapper">
            <div className="saving-pots content-wrapper">
              <div className="reducePot__body">
                <div className="row">
                  <div className="col-xs-12 reducePot_header">
                    {/* for Mobile view only*/}
                    {BrowserUtils.isMobileView() && this._getLeftProgress()}

                    <h3 className="panel-title">Savings Pots</h3>
                    {/* <MobileOverlay getHeaderClass={this.getHeaderClass} selectedTab="savingpots" content={this.props.content} openFaq={this.openFaq} />*/}
                  </div>
                  <div className="col-sm-4 col-xs-12">
                    {/* for Desktop view only*/}
                    {!BrowserUtils.isMobileView() && this._getLeftProgress()}

                    {balanceHeaderContent}
                  </div>
                  <div className="col-sm-8 col-xs-12">
                    <div className="row reduce--header">
                      <div className="col-xs-6 text-left">
                        <h3>{content.savingpotTitle}</h3>
                      </div>
                      <div className="col-sxs-4 text-center">
                        <h3>{content.savingpotAllocatedTitle}</h3>
                      </div>
                      <div className="col-sxs-2 text-center" />
                    </div>
                    <div className="reduce__content">
                      {pots.map((pot, i) => (
                        <ReducePotList
                          content={content}
                          getFull={this.props.getFull}
                          getKey={i}
                          key={i}
                          getAccountColor="green"
                          pot={pot}
                          id={i}
                          selected={this.state.selections[i]}
                          onToggle={this._onChildToggle}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReducePot.propTypes = {
  pots: PropTypes.array,
  getPotPageHandleClick: PropTypes.func,
  content: PropTypes.object,
  accountClass: PropTypes.string,
  accDetails: PropTypes.object,
  getFull: PropTypes.object,
  getSelectedAccountID: PropTypes.string,
  interPotError: PropTypes.object,
};

export { ReducePot };
